var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.351,
    height: 16.396,
    viewBox: "0 0 42.351 16.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plug_1_",
    "data-name": "plug (1)",
    d: "M14.78,5.374H12.092V1.344a1.344,1.344,0,1,0-2.687,0V5.374H6.718V1.344a1.344,1.344,0,1,0-2.687,0V5.374H1.344a1.344,1.344,0,0,0,0,2.687v2.687a6.729,6.729,0,0,0,5.374,6.582V21.5H9.405V17.331a6.729,6.729,0,0,0,5.374-6.582V8.062a1.344,1.344,0,0,0,0-2.687Zm-4.031,6.718H5.374V9.405h5.374Z",
    transform: "translate(18.853 16.123) rotate(-90)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M189.289,108.076v2.687m0,2.685v2.687a1.343,1.343,0,0,1-2.686,0h-2.687a6.74,6.74,0,0,1-6.582-5.376h-4.167v-2.687h4.167a6.739,6.739,0,0,1,6.582-5.373H186.6a1.343,1.343,0,0,1,2.686,0v2.685m-4.03,6.721v-5.376h-2.686v5.376Z",
    transform: "translate(-175.166 -101.082)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.76f015a417ed99367bc0b81876e83c66.svg";
export { ForwardRef as ReactComponent };